import { Content } from "@iventis/translations/content/typed-content";
import { PeopleViewMachineEvents, PeopleViewMachineEventType, ConfirmationDialogContent, PeopleViewAction } from "@iventis/people";
import { translate } from "@iventis/translations/translation";
import { enableSso, disableSso, removePeople, resetPasswords } from "@iventis/permissions/src/people-api-functions";

export function getConfirmationDialogContent(
    action: PeopleViewAction,
    send: (event: PeopleViewMachineEvents) => void,
    callbacks: { onRemovePeople: (userIds: string[]) => void }
): ConfirmationDialogContent {
    switch (action) {
        case PeopleViewAction.REMOVE:
            return {
                title: translate(Content.people.remove_people.remove_user_title),
                icon: ["far", "user-slash"],
                message: [translate(Content.people.remove_people.remove_user_message), translate(Content.people.remove_people.remove_user_message_continue)],
                toast: translate(Content.people.remove_people.remove_people_success),
                toastTestId: "remove-people-success-toast",
                apiCall: removePeople(callbacks?.onRemovePeople),
                callBack: (userIds: string[]) => {
                    send({ type: PeopleViewMachineEventType.REMOVE_PEOPLE, payload: userIds });
                },
            };
        case PeopleViewAction.RESET_PASSWORD:
            return {
                title: translate(Content.people.reset_password.reset_password_title),
                icon: ["far", "passport"],
                message: [translate(Content.people.reset_password.reset_password_message), translate(Content.people.reset_password.reset_password_message_continue)],
                toast: translate(Content.people.reset_password.reset_password_success),
                apiCall: resetPasswords,
                callBack: (userIds: string[]) => {
                    send({ type: PeopleViewMachineEventType.UPDATE_SELECTION, payload: { ids: userIds, selected: false } });
                },
            };
        case PeopleViewAction.ENABLE_SSO:
            return {
                title: translate(Content.people.sso.title),
                icon: ["far", "key"],
                message: [translate(Content.people.sso.confirm), translate(Content.people.sso.continue)],
                toast: translate(Content.people.sso.success),
                apiCall: enableSso,
                callBack: (userIds: string[]) => {
                    send({ type: PeopleViewMachineEventType.UPDATE_PEOPLES_SSO, payload: { userIds, enabled: true } });
                    send({ type: PeopleViewMachineEventType.UPDATE_SELECTION, payload: { ids: userIds, selected: false } });
                },
            };
        case PeopleViewAction.DISABLE_SSO:
            return {
                title: translate(Content.people.sso_disable.title),
                icon: ["far", "slash"],
                message: [translate(Content.people.sso_disable.confirm), translate(Content.people.sso_disable.continue)],
                toast: translate(Content.people.sso_disable.success),
                apiCall: disableSso,
                callBack: (userIds: string[]) => {
                    send({ type: PeopleViewMachineEventType.UPDATE_PEOPLES_SSO, payload: { userIds, enabled: false } });
                    send({ type: PeopleViewMachineEventType.UPDATE_SELECTION, payload: { ids: userIds, selected: false } });
                },
            };
        default:
            throw new Error(`Action ${action} is not supported`);
    }
}
